module.exports = __webpack_public_path__ + "img/eth.a376ad16.png";